import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '../Icon/Icon.es.js';

const tableHeadSortButton = "_table-head-sort-button_1xs64_1";
const styles = {
	tableHeadSortButton: tableHeadSortButton
};

const TableHeadSortButton = (props) => {
  return jsxs("button", { type: "button", className: styles.tableHeadSortButton, onClick: props.onClick, "data-zds": true, children: [props.children, jsx(Icon, { color: "GrayWarm6", name: "arrowDropdown", size: 16 })] });
};

export { TableHeadSortButton };
//# sourceMappingURL=TableHeadSortButton.es.js.map
